export default __webpack_public_path__ + "static/media/MTD.e06712b5.svg";